import React from 'react';

function Academics() {
  return (
    <main className="academics-page" id="academics">
      {/* Hero Header */}
      <section className="academics-hero" aria-labelledby="academics-title">
        <div className="academics-hero-inner">
          <div className="academics-hero-copy">
            <p className="academics-eyebrow">Academic Excellence &amp; Discipline</p>
            <h1 id="academics-title">Academics &amp; <span>School Policies</span></h1>
            <p className="academics-lead">
              Comprehensive guidelines, admission procedures, exam regulations, and code of conduct for Shree Umiya Patidar H.S. School.
            </p>
          </div>
          <div className="academics-emblem" aria-hidden="true">
            <span className="about-emblem-ring">विद्या ददाति विनयं</span>
          </div>
        </div>
      </section>

      {/* Main Content Area */}
      <div className="academics-content">
        <div className="academics-container">

          {/* Admission Process & Timings */}
          <section className="academics-section" aria-labelledby="admission-heading">
            <p className="academics-section-kicker">Joining Our Institution</p>
            <h2 id="admission-heading">Admission Process &amp; Timings</h2>
            
            <div className="academics-card">
              <h3>India Tour Scheme</h3>
              <p>Information on various states, historical, and religious places.</p>
            </div>

            <div className="academics-card">
              <h3>Admission Guidelines <em>(Slogan: Knowledge bestows humility)</em></h3>
              <ul className="academics-list">
                <li>Authorized birth certificate is required at the time of first admission.</li>
                <li>Permanent Caste Certificate (issued by a competent authority).</li>
                <li>Transfer Certificate (TC).</li>
                <li>Attested copy of the mark sheet.</li>
                <li>School admission application form.</li>
                <li>Admission fee.</li>
                <li>Admission test (written and oral).</li>
                <li>Photo of the student seeking admission.</li>
                <li>Income Certificate (for Class 6th to 12th).</li>
                <li>Enrollment Number (for Class 10th to 12th).</li>
                <li>SSSM - ID Number.</li>
                <li>Family - ID Number.</li>
              </ul>
            </div>

            <div className="academics-card highlight-card">
              <h3>School and Office Timings</h3>
              <p><strong>Timings:</strong> 10:00 AM to 3:00 PM</p>
            </div>
          </section>

          {/* School Rules & Discipline */}
          <section className="academics-section" aria-labelledby="rules-heading">
            <p className="academics-section-kicker">Conduct &amp; Discipline</p>
            <h2 id="rules-heading">School Rules &amp; Discipline</h2>
            
            <div className="academics-card">
              <h3>Rules of Discipline for Students</h3>
              <p>Students are expected to follow instructions for the development of the School:</p>
              <ul className="academics-list">
                <li>Always come to school in a proper, neat &amp; clean uniform.</li>
                <li>Move in a line to the class &amp; within the school premises.</li>
                <li>No provision for half-day leave. In case of emergency, parents should come to school with an application.</li>
                <li>Be regular to school. 80% attendance is compulsory for the annual exam; otherwise, students will not be allowed to appear in the exam.</li>
                <li>Do not remain absent without information &amp; permission; otherwise, the name will be struck off after 7 days and a re-admission fee of Rs. 2000/- will be charged.</li>
                <li>Maintain classwork and homework notebooks, and get them checked by the teacher before the annual exam.</li>
                <li>Respect elders &amp; teachers, obey them, and be friendly with classmates.</li>
              </ul>
            </div>

            <div className="academics-card warning-card">
              <h3>Disciplinary Action</h3>
              <p>Students are bound to observe the code of discipline strictly. Delinquency or infringement of any rule will warrant disciplinary action by the management:</p>
              <ol className="academics-ordered-list">
                <li>Oral/written warning to the student &amp; parents.</li>
                <li>Suspension from attending class/school.</li>
                <li>Rustication from school.</li>
                <li>Issue of Transfer Certificate.</li>
              </ol>
            </div>

            <div className="academics-card">
              <h3>Certification and Attestation</h3>
              <p>For any kind of school-related certificate, there should be a written application from the parents/students addressed to the Principal. It will take a minimum of 2 days to issue the certificate.</p>
            </div>

            <div className="academics-card">
              <h3>General Rules for Students</h3>
              <ul className="academics-list">
                <li>All students are to come to school regularly &amp; punctually.</li>
                <li>During school hours no student shall leave the school premises without the permission of the principal nor will anyone be allowed to meet any student.</li>
                <li>Any kind of damage done to school property is to be made good.</li>
                <li>Eye-teasing, passing comments &amp; misbehaving with girls will warrant disciplinary action.</li>
                <li>Homework should be taken down in the handbook in good handwriting, with date. Assignments should be completed at home without fail.</li>
                <li>Students are to obtain the signature of parents/guardians on any remarks/notice/letter without fail. Similarly, any note/letter from parents should be shown to the teacher &amp; acknowledgment obtained.</li>
                <li>Objectionable objects, such as CDs, Cassettes, Camera, Mobile, Electronic Gadgets, Sharp Tools &amp; ornaments are not allowed to School.</li>
                <li>School is not responsible for the articles/money lost. No costly jewellery should be worn.</li>
                <li>Ignorance of any rule is no excuse.</li>
                <li>Birthday celebrations are not allowed.</li>
              </ul>
            </div>
          </section>

          {/* School Uniform 2026-27 */}
          <section className="academics-section" aria-labelledby="uniform-heading">
            <p className="academics-section-kicker">Dress Code</p>
            <h2 id="uniform-heading">School Uniform (2026–27)</h2>
            
            <div className="academics-card">
              <h3>General Uniform Guidelines</h3>
              <p>Students should attend School in a proper uniform daily, washed cleanly, ironed well &amp; properly worn. Shoes must be polished, socks fitting, and ID card to be properly attired. Students must wear House uniform on special days. Long Hair, bearded tattoo, one plait, long nail, nail polish, hair style etc. are strictly forbidden. Any part of uniform torn out loose, tight, altered or unfit will not be allowed.</p>
            </div>

            <div className="academics-grid">
              <div className="academics-card">
                <h3>Uniform I (Monday, Tuesday, Thursday, Friday)</h3>
                
                <h4>Nursery to K.G. - II</h4>
                <p><strong>Boys:</strong> Shirt, Pant, Shoes, Socks, Belt</p>
                <p><strong>Girls:</strong> Frock, Ribbon, Shoes, Socks</p>

                <h4>I to VIII</h4>
                <p><strong>Boys:</strong> Shirt, Pant, Belt, Shoes, Socks</p>
                <p><strong>Girls:</strong> Shirt, Skirt, Belt, Shoes, Socks, Ribbon</p>

                <h4>IX to XII</h4>
                <p><strong>Boys:</strong> Shirt, Pant, Belt, Shoes, Socks, Blazer (Winter)</p>
                <p><strong>Girls:</strong> Salwar Kurti, Waistcoat, Ribbon, Shoes, Socks, Blazer (Winter)</p>
              </div>

              <div className="academics-card">
                <h3>Uniform II (Wednesday &amp; Saturday)</h3>
                
                <h4>Nursery to K.G. - II</h4>
                <p><strong>Boys:</strong> T-Shirt Orange, Blue Lower, Shoes, Socks</p>
                <p><strong>Girls:</strong> T-Shirt Orange, Blue Lower, Shoes, Socks</p>

                <h4>I to V</h4>
                <p><strong>Boys:</strong> T-Shirt Orange, Blue Lower, Shoes, Socks</p>
                <p><strong>Girls:</strong> T-Shirt Orange, Blue Lower, Shoes, Socks</p>

                <h4>VI to XII</h4>
                <p><strong>Boys:</strong> Track Suit, Shoes, Socks</p>
                <p><strong>Girls:</strong> Track Suit, Shoes, Socks</p>
              </div>
            </div>
          </section>

          {/* Parent Guidelines */}
          <section className="academics-section" aria-labelledby="parents-heading">
            <p className="academics-section-kicker">Parent Partnership</p>
            <h2 id="parents-heading">Guidelines for Parents</h2>
            
            <div className="academics-card">
              <h3>General Guidelines</h3>
              <ul className="academics-list">
                <li>Parents/Guardians or any other visitors are strictly forbidden to visit the Classroom &amp; talk to the teachers or students during school hours.</li>
                <li>Parents have to reply to letter/diary note of the teacher &amp; vice-versa.</li>
                <li>Change of address, telephone number etc. should be intimated to the office &amp; to the class teacher by a written application.</li>
                <li>Parents of primary section are requested to send only those books &amp; note books as per the time table for your ward's convenience.</li>
                <li>Parents are requested to comply with the visiting hours of the Principal, Administrator &amp; the office.</li>
                <li>It is the duty of Parents to see that their wards are regular, neat &amp; tidy to School &amp; bring all their necessary books &amp; other learning materials according to the time table.</li>
              </ul>
            </div>

            <div className="academics-card">
              <h3>Parent Code &amp; Regulations</h3>
              <ul className="academics-list">
                <li>If a student's behavior and conduct are found unsatisfactory by the school, the parent will be informed; if no improvement is made, the student may be expelled.</li>
                <li>Irregular attendance, bad habits, disobedience, and characterlessness will result in immediate expulsion from the school.</li>
                <li>Strikes, shutdowns, protests, rowdy behavior, or misbehavior with other students and staff will lead to expulsion.</li>
                <li>The prescribed fee must be paid in 3 installments in June, September, and December. A late fine of Rs. 10 per day will be charged after the due date.</li>
                <li>Bring the old receipt along when paying fees.</li>
                <li>Parents should meet the Principal/Director/Teacher only during fixed visiting hours so that studies are not disrupted.</li>
                <li>Parents/guardians must contact the Principal or Director monthly (on the last working day) to get information about their child's progress.</li>
                <li>If parents/guardians have any complaints, contact the Principal or Director directly, not any teacher.</li>
                <li>Students must maintain the dignity of the school outside campus through polite behavior and good character.</li>
                <li>All rules passed by the institution from time to time are mandatory for every student to follow.</li>
                <li>Half-day leave will not be granted to students.</li>
                <li>Parents' cooperation is essential, and attendance in all meetings is compulsory.</li>
                <li>Parents must send their ward to school daily and stay fully informed of their activities. Pay all fees on time.</li>
                <li>Bringing two-wheeled vehicles (motorcycles/scooters) to school by students is prohibited; otherwise, parents will be held responsible.</li>
              </ul>
            </div>
          </section>

          {/* Transfer Certificate, Stationeries & Computer Education */}
          <section className="academics-section" aria-labelledby="tc-heading">
            <p className="academics-section-kicker">Administrative &amp; Technology</p>
            <h2 id="tc-heading">TC, Stationeries &amp; Computer Education</h2>
            
            <div className="academics-grid">
              <div className="academics-card">
                <h3>Transfer Certificate (T.C.)</h3>
                <p>Transfer Certificate shall be issued only after clearing all dues of school.</p>
                <p>Parents wishing to withdraw their wards have to submit a T.C. application as per prescribed form available in office soon after the final result is declared. The last date is 30th May. After the due date, one month school fee shall be charged.</p>
              </div>

              <div className="academics-card">
                <h3>Books, Notebooks &amp; Caution Money</h3>
                <p><strong>Books &amp; Notebooks:</strong> The list of prescribed books and note books shall be displayed on the notice board. Parents are at liberty to buy books &amp; uniform from any shop they like.</p>
                <p><strong>Caution Money:</strong> For refund of Caution Money an application along with the receipt should be submitted within one month of withdrawal of your ward.</p>
              </div>
            </div>

            <div className="academics-card highlight-card">
              <h3>Computer Education</h3>
              <p>Computer Education is the first need of the era. It is true that Computer education is needed on every walk of the life today. The basic knowledge of Computer is necessary for everybody whether he is a Doctor, Engineer or any one else. The importance of computer will increase day by day.</p>
              <p>The Student of Shree Umiya Patidar H.S. School be ahead in every field &amp; He/She must have the knowledge of computer that is why Computer education is provided to every student right from class 1st.</p>
            </div>
          </section>

          {/* Test / Exam Terms & Conditions */}
          <section className="academics-section" aria-labelledby="exam-heading">
            <p className="academics-section-kicker">Assessment Framework</p>
            <h2 id="exam-heading">Test / Exam Terms &amp; Conditions</h2>
            
            <div className="academics-card">
              <ul className="academics-list">
                <li>Unit Test will be conducted in every session, between 20th to 30th of every month.</li>
                <li>Absence without valid reason in any examination or part will excluded Rank &amp; Merit List. No other arrangement of exam will be made. In case 9th &amp; 11th Supplementary Exam will be conducted in 2 subjects only &amp; in 10th &amp; 12th it will be only in one subject.</li>
                <li>Application for the verification of Marks / Grade, in exception case, may be considered at the direction of head of the School. However answer script in such cases will not be shown to the parents, pupils.</li>
                <li>No retest will be conducted for any test/exam, except Annual exam.</li>
                <li>Science practical exam of Class 10th &amp; 12th will be conducted as M.P. Board time-table. And for class 9th &amp; 11th it will be conducted before annual examination.</li>
                <li>Students from class Nursery to 1st will get two in one question paper (no separate question paper). Students from class 2nd onwards will get printed question paper in exams.</li>
                <li>Application for scrutinizing (totaling) of answer books of annual examination may be given within a week from the day of declaration of result (charge will be Rs 25 per subject), no application will be entertained after a week.</li>
                <li>Completion of 80% of attendance upto annual exam is must for all the students.</li>
              </ul>
            </div>
          </section>

          {/* Co-Curricular & Sports */}
          <section className="academics-section" aria-labelledby="cocurricular-heading">
            <p className="academics-section-kicker">Beyond Academics</p>
            <h2 id="cocurricular-heading">Co-Curricular, Sports &amp; Social Activities</h2>
            
            <div className="academics-grid">
              <div className="academics-card">
                <h3>Games &amp; Sports</h3>
                <p>All the pupils are expected to take an active participation in Physical Education, Games &amp; Yoga arranged in the school. Competitions will be held during Sport meet (Annual Sports Week) Monitors will be selected from the outstanding pupils &amp; sportsmen. They will assist the class teachers in organizing Games &amp; Sports.</p>
              </div>

              <div className="academics-card">
                <h3>Co-Curricular Activities</h3>
                <p>Form an Internal part of student's life, competition in games, sports, art, music, science educational visits are some co-curricular activities. Our school provides Cultural, Professional debate, quiz etc.</p>
              </div>
            </div>

            <div className="academics-card">
              <h3>Social Activities</h3>
              <p>The students are motivated to support &amp; help the needy people in the Society.</p>
            </div>
          </section>

        </div>
      </div>
    </main>
  );
}

export default Academics;